import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios';
import { withGlobalError } from '@/react-tools/react-query';

import { PolicyId } from '../types';

import { queryKeys } from './query-keys';

export function useDeletePoliciesMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deletePolicies,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.list() });
    },
    ...withGlobalError('Unable to delete policies'),
  });
}

async function deletePolicies(ids: PolicyId[]): Promise<void> {
  try {
    await Promise.all(ids.map((id) => deletePolicy(id)));
  } catch (error) {
    throw parseAxiosError(error, 'Unable to delete policies');
  }
}

async function deletePolicy(id: PolicyId): Promise<void> {
  try {
    await axios.delete(`/policies/${id}`);
  } catch (error) {
    throw parseAxiosError(error, 'Unable to delete policy');
  }
}
